import React, { Component } from "react";

import register from '../component/register.png';
import '../reward.css';
import {aesEncrypt} from "../../../util/aes256";

class RewardIndexContainer extends Component {
    constructor(props) {
        super(props);

        this.handleKakaoLogin = this.handleKakaoLogin.bind(this);
        this.handleNaverLogin = this.handleNaverLogin.bind(this);

        this.state = {};
    }

    handleKakaoLogin() {
        const { data } = this.props;

        const state = {
            type: 'KAKAO',
            data: data,
            clientId: process.env.REACT_APP_SYNC_CLIENT_ID,
        }
        const encodedState = encodeURIComponent(aesEncrypt(JSON.stringify(state)));

        let url = `https://kauth.kakao.com/oauth/authorize`;
        url += `?prompt=select_account`;
        url += `&client_id=${process.env.REACT_APP_SYNC_CLIENT_ID}`;
        url += `&redirect_uri=${process.env.REACT_APP_SYNC_REDIRECT_URI_REWARD}`;
        url += `&response_type=code`;
        url += `&state=${encodedState}`;

        window.location.href = url;
    }

    handleNaverLogin() {
        const { data } = this.props;

        const state = {
            type: 'NAVER',
            data: data,
            clientId: process.env.REACT_APP_NAVER_LOGIN_CLIENT_ID,
        }
        const encodedState = encodeURIComponent(aesEncrypt(JSON.stringify(state)));

        let url = `https://nid.naver.com/oauth2.0/authorize`;
        url += `?client_id=${process.env.REACT_APP_NAVER_LOGIN_CLIENT_ID}`;
        url += `&redirect_uri=${process.env.REACT_APP_NAVER_LOGIN_REDIRECT_URI_REWARD}`;
        url += `&response_type=code`;
        url += `&state=${encodedState}`;

        window.location.href = url;
    }

    render() {
        return (
            <div className="register-outer">
                <img src={register} alt="register.png" className="register-image"/>
                <button
                    onClick={this.handleKakaoLogin}
                    className="btn-kakao-reward btn btn-md w-100 lh-base"
                >
                    <span>카카오로 시작하기</span>
                </button>
                <button
                    onClick={this.handleNaverLogin}
                    className="btn-naver-reward btn btn-md w-100 lh-base"
                >
                    <span>네이버로 시작하기</span>
                </button>
            </div>
        )
    }
}

export default RewardIndexContainer;
